import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { PropsWithChildren, ReactNode } from 'react'

export type BulletPointsType = {
  icon?: SVGFC
  label: string
  variant?: 'title' | 'point'
}

type Props = {
  title?: string
  subtitle?: string | ReactNode
  bulletPoints?: BulletPointsType[]
  imagePath: string
}

const OverviewCardDetails = ({
  subtitle,
  bulletPoints,
  imagePath,
  children
}: PropsWithChildren<Props>) => {
  return (
    <InnerBox className="rounded-lg p-4 mobile:p-3 bg-white-hover flex mobile:flex-col flex-row items-center justify-between mobile:items-start">
      <div className="flex flex-col">
        {subtitle && typeof subtitle === 'string' ? (
          <>
            <Typography variant="text" color={tailwindColors.grey.DEFAULT}>
              {subtitle}
            </Typography>
            <div className="h-3" />
          </>
        ) : (
          <>{subtitle}</>
        )}
        {bulletPoints && (
          <div className="flex flex-col gap-2">
            {bulletPoints.map((point, index) => (
              <div className="flex gap-1 items-center" key={index}>
                {point.icon && (
                  <div className="bg-primary-light p-0.5 rounded-full w-6 h-6 flex justify-center items-center">
                    <point.icon color={tailwindColors.primary.DEFAULT} />
                  </div>
                )}
                <Typography
                  variant={point.variant === 'title' ? 'tag' : 'secondary-body'}
                  color={
                    point.variant === 'title'
                      ? tailwindColors.primary.DEFAULT
                      : tailwindColors.grey.DEFAULT
                  }
                >
                  {point.label}
                </Typography>
              </div>
            ))}
          </div>
        )}
        {children}
      </div>
      <img src={imagePath} alt="card-image" className="w-60 h-52 object-fit" />
    </InnerBox>
  )
}

const OverviewCard = ({ title, ...props }: PropsWithChildren<Props>) => {
  if (title)
    return (
      <InnerBox className="rounded-lg p-4 flex flex-col gap-3">
        <Typography variant="sub-heading" color={tailwindColors.primary.DEFAULT}>
          {title}
        </Typography>
        <OverviewCardDetails {...props} />
      </InnerBox>
    )
  return <OverviewCardDetails {...props} />
}

export default OverviewCard
